<template>
  <section id="about">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="7">
              <h1 class="font-weight-light display-2">Sobre</h1>
              <h1 class="font-weight-light display-1 mb-3">
                ABMODEL Solutions
              </h1>
              <v-row>
                <v-col
                  cols="12"
                  v-for="aboutUsitem of aboutUsList"
                  class="d-flex"
                >
                  <div
                    class="contenedor-icono d-flex flex-column justify-center text-center"
                  >
                    <v-icon x-large color="primary">
                      fas {{ aboutUsitem.Icono }}
                    </v-icon>
                    <div class="mt-2 uppercased primary-color">
                      <b>{{ aboutUsitem.Titulo }}</b>
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <p class="text-justify mb-0">
                      {{ aboutUsitem.Descripcion }}
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="5" class="d-none d-md-flex">
              <v-img
                src="@/assets/img/ill1.svg"
                class="d-block ml-auto mr-auto"
                max-width="400px"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
    aboutUsList: [
      {
        Titulo: "Visión",
        Descripcion:
          "Nuestra visión es ser una de las mejores empresas a nivel nacional en la provisión de servicios especializados de tecnologías de la información, entregando confianza en el funcionamiento y operación de plataformas informáticas de nuestros clientes y liberando de preocupaciones a estos últimos, para que se concentren plenamente en el crecimiento de sus negocios.",
        Icono: "fa-handshake",
      },
      {
        Titulo: "Misión",
        Descripcion:
          "Ofrecemos servicios y soluciones en el diseño, desarrollo y mantención de software para nuestros actuales y potenciales clientes que necesiten un servicio de máxima excelencia. Para ello el equipo ofrece eficiencia y eficacia en el desempeño para entregar confianza a nuestros clientes.",
        Icono: "fa-award",
      },
    ],
  }),
};
</script>

<style scoped>
#about {
  background-color: #f4f7f5;
}
.primary-color {
  color: var(--v-primary-base);
}
.contenedor-icono {
  min-width: 100px;
}
</style>
